<script>
  export default {
    name: "W8BenE",
    props: ['view'],
    data() {
      return {
        part: 1,
        part_XXIX_string: '',
        part_XXIX: [],
        certify: false,
        submited: false
      }
    },
    computed: {
      parts() {
        return `${this.part}/30`;
      }
    },
    watch: {
      part_XXIX: {
        deep: true,
        handler(val) {
          this.part_XXIX_string = JSON.stringify(val);
        }
      }
    },
    methods: {
      prev() {
        this.part--;
      },
      next() {
        this.part++;
      },
      addPartXXIX() {
        this.part_XXIX.push({
          name: '',
          address: '',
          tin: ''
        });
      },
      save(e) {
        if (this.certify) {
          e.target.submit();
          this.submited = true;
          return;
        }

        this.part = 30;

        alertMsg('error', this.view.translations.pleaseCertify);

        return false;
      }
    },
    mounted() {
      if (this.view.form && this.view.form.part_XXIX) {
        this.part_XXIX = JSON.parse(this.view.form.part_XXIX);
        this.part_XXIX_string = this.view.form.part_XXIX;
      } else {
        this.part_XXIX.push({
          name: '',
          address: '',
          tin: ''
        });
      }
    }
  }
</script>


// WEBPACK FOOTER //
// resources/office/js/components/W8BenE.vue